export enum ToastNotificationType {
    NEGATIVE = 'cdc-negative',
    PARTIAL_POSITIVE = 'cdc-partial-positive',
    POSITIVE = 'cdc-positive'
  }
